<template>
  <div class="kpi-summary-row" :class="gridClass">
    <div class="kpi-summary-row__label">
      {{ column.summary.label }}
    </div>
    <div  v-for="(wave, index) in waves"
          :key="index"
          class="kpi-summary-row__value"
          :class="[
            `kpi-summary-row__value--${getStatus(wave.Name)}`,
            { 'kpi-summary-row__value--current': wave.isCurrent }
          ]">
      {{ getValue(wave.Name) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiSummaryRow',

  props: {
    column: {
      type: Object,
      required: true
    }
  },

  computed: {
    waves() {
      return this.column.isExpanded
        ? this.column.waves
        : this.column.waves.slice(-1);
    },
    gridClass() {
      if (this.waves?.length > 1) {
        return 'kpi-summary-row--multi';
      }
      return 'kpi-summary-row--single';
    }
  },

  methods: {
    getValue(waveName) {
      const wave = this.column.summary.SurveyWave.find(
        (w) => w.Name === waveName);
      return wave ? wave.Result : 'N/A';
    },
    getStatus(waveName) {
      const wave = this.column.summary.SurveyWave.find(w => w.Name === waveName);
      if (!wave) return null;

      if (wave.Result <= 50) return 'red';
      if (wave.Result <= 75) return 'yellow';
      return 'green';
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-summary-row {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.75rem 0.5rem;
  // background-color: rgba(var(--bs-gray-100-rgb), 0.5);
  // border-bottom: 2px solid var(--bs-gray-300);
  border-bottom: 2px solid var(--bs-border-color);

  &--single {
    display: grid;
    grid-template-columns: minmax(8rem, 1fr) repeat(1, 4rem);
    gap: 0.125rem;
  }

  &--multi {
    display: grid;
    grid-template-columns: minmax(8rem, 1fr) repeat(v-bind('waves.length'), 4rem);
    gap: 0.125rem;
  }
}

.kpi-summary-row__label {
  flex: 1;
  font-size: 0.75rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.kpi-summary-row__value {
  text-align: center;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius);
  padding: 0.125rem 0.25rem;

  &--current {
    font-weight: 700;
  }

  &--green {
    border-left: 4px solid var(--bs-success);
    background-color: rgba(var(--bs-success-rgb), 0.1);
  }

  &--yellow {
    border-left: 4px solid var(--bs-warning);
    background-color: rgba(var(--bs-warning-rgb), 0.1);
  }

  &--red {
    border-left: 4px solid var(--bs-danger);
    background-color: rgba(var(--bs-danger-rgb), 0.1);
  }
}
</style>
